import { MuiChip } from '@/components/chip/MuiChip';
import { SxProps, Typography } from '@mui/material';
import { MuiAvatar } from '@/components/avatar/MuiAvatar';
import IbowOfficePNG from '@/../public/dx_normal.png';

type Props = {
  sxProps?: SxProps;
};

export function DxStationLabel({ sxProps }: Props) {
  return (
    <MuiChip
      avatar={<MuiAvatar src={IbowOfficePNG.src} />}
      label={
        <Typography variant="JP/Body/m/Medium/None" sx={{ color: '#0079C3' }}>
          DXステーション
        </Typography>
      }
      sx={{
        backgroundColor: '#F5FAF9',
        borderRadius: 1,
        height: '30px',
        pl: 0.5,
        pr: 1,
        '.MuiChip-avatar': {
          m: 0,
          img: {
            width: 20,
            height: 20,
          },
        },
        '.MuiChip-label': {
          pl: 0.25,
          pr: 0,
        },
        ...sxProps,
      }}
    />
  );
}
